import React from 'react';
import {Navigate} from 'react-router';
import {connect} from 'react-redux';

// `staffOnly` protege las pantallas administrativas: un usuario logueado sin
// is_staff que entre por URL vuelve al dashboard en vez de ver la pantalla.
const PrivateRoute = ({children, loggedIn, isStaff, staffOnly = false}) => {
    if (!loggedIn) return <Navigate to="/" replace/>;
    if (staffOnly && !isStaff) return <Navigate to="/dashboard" replace/>;
    return children;
};

const mapStateToProps = state => ({
    loggedIn: state.user.loggedIn,
    isStaff: state.user.is_staff,
});

export default connect(mapStateToProps)(PrivateRoute);
